module.exports = __webpack_public_path__ + "static/media/nopromocode.b349d892.svg";